// extracted by mini-css-extract-plugin
module.exports = {"action":"styles_action__3MW6R","quantity":"styles_quantity__3tXgD","price":"styles_price__35xFj","title":"styles_title__1Vxv_","value":"styles_value__BAHCA"};